/* Lucian UX/UI Prompt #032 · MIT License (c) 2026 Seokwoooo · https://lucianlabs.dev/uxui-prompt/#032 */
import { useRef, useState } from 'react';
import './lucian-032.css';

const TYPE = { png: '#2563c9', jpg: '#17784f', jpeg: '#17784f', webp: '#6a48d6', gif: '#8a5a00' };

// 원본의 흉내 진행 대신 실제 검색 단계(jobs[].p)를 그린다.
// status: 'ready' | 'wait' | 'error'  ·  jobs: [{ id, name, p, state:'run'|'done'|'fail', note }]
export default function LucianImageDrop({ status, waitLabel, waitProgress, onFile, onRetryModel, onRetryJob, jobs, inputId }) {
  const pickRef = useRef(null);
  const depth = useRef(0);
  const [over, setOver] = useState(false);
  const ready = status === 'ready';

  const choose = () => {
    if (status === 'error') return onRetryModel();
    if (ready) pickRef.current?.click();
  };
  const take = files => { const f = files && files[0]; if (f && ready && f.type.startsWith('image/')) onFile(f); };

  return (
    <div className={`ux u032 u032-site ${over ? 'is-over' : ''} ${status === 'wait' ? 'is-wait' : ''} ${status === 'error' ? 'is-error' : ''}`}>
      <button
        className="u032-zone" type="button" onClick={choose} aria-disabled={status === 'wait'}
        onDragEnter={e => { e.preventDefault(); depth.current++; setOver(true); }}
        onDragOver={e => e.preventDefault()}
        onDragLeave={() => { if (--depth.current <= 0) { depth.current = 0; setOver(false); } }}
        onDrop={e => { e.preventDefault(); depth.current = 0; setOver(false); take(e.dataTransfer.files); }}
      >
        <svg className="u032-dash" aria-hidden="true"><rect width="100%" height="100%" rx="25" /></svg>
        <span className="u032-orb" aria-hidden="true"><svg viewBox="0 0 28 28"><path d="M5 9.5h3.5l2-3h7l2 3H23v12H5z" /><circle cx="14" cy="15" r="3.8" /></svg></span>
        {status === 'ready' && <><b>캡처를 끌어다 놓거나 <em>골라 주세요</em></b><small>라이브 화면 캡처로 원본 영상과 장면을 찾아요</small></>}
        {status === 'wait' && <><b>사진 검색 준비 중</b><small>{waitLabel}</small></>}
        {status === 'error' && <><b>AI를 불러오지 못했어요</b><small>눌러서 다시 시도</small></>}
        {status === 'wait' && waitProgress > 0 && <span className="u032-prog" aria-hidden="true"><i style={{ '--p': waitProgress }} /></span>}
      </button>
      <input ref={pickRef} id={inputId} className="u032-file" type="file" accept="image/*" tabIndex={-1} aria-hidden="true"
        onChange={e => { take(e.target.files); e.target.value = ''; }} />
      <ul className="u032-list" aria-live="polite">
        {jobs.map(j => {
          const ext = (j.name.split('.').pop() || '').toLowerCase();
          return (
            <li key={j.id} className={`u032-row ${j.state === 'done' ? 'done' : ''} ${j.state === 'fail' ? 'fail' : ''}`} style={{ '--p': j.p }}>
              <span className="u032-ic" style={{ '--c': TYPE[ext] || '#5c6069' }} aria-hidden="true">{ext.slice(0, 3).toUpperCase() || 'IMG'}</span>
              <span className="u032-meta"><b>{j.name}</b><small>{j.note}</small></span>
              {j.state === 'fail'
                ? <button className="u032-retry" type="button" onClick={() => onRetryJob(j)}>다시 시도</button>
                : <span className="u032-st">{j.state === 'run'
                  ? <span className="u032-spin" aria-hidden="true" />
                  : <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 8.4l3 3 6-6.4" /></svg>}</span>}
              <span className="u032-bar" aria-hidden="true" />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
